/**
 * English translations for the free test feature
 */
const freeTest = {
  freeTest: {
    // Free test page
    title: "Free Purple Star Astrology Chart Visualization",
    subtitle: "Try our Purple Star Astrology chart for free!",
    limitedTime: "FREE TEST - No Account Required",
    aboutTitle: "About This Free Test",
    aboutDescription: "This free test allows you to experience the power of Purple Star Astrology chart analysis without creating an account.",
    whatYouGet: "What You'll Get",
    feature1: "Full Purple Star Astrology chart visualization",
    feature2: "Basic personality analysis",
    feature3: "Life areas overview",
    fullFeatures: "Want Full Features?",
    upgradeDescription: "Contact us on WhatsApp for full analysis, personalized consultation and more.",
    signUpCta: "Contact on WhatsApp",
    tryAgain: "Try Again",

    // Free result page
    resultTitle: "Free Chart Results",
    resultTitleSuffix: "'s Free Chart Results",
    resultSubtitle: "Purple Star Astrology chart free test results",
    upgradeTitle: "Unlock Full Analysis",
    upgradeBenefits: "Contact us on WhatsApp for full personalized analysis, consultation, and more!",
    createAccount: "Contact on WhatsApp",
    createAnother: "Create Another Chart",
    previewVersion: "Preview Version",
    limitedAnalysis: "Limited Preview Analysis",
    limitedAnalysisDesc: "This free test provides a preview of our basic analysis. Contact us on WhatsApp to unlock the full detailed analysis and personalized interpretation of your chart.",
    unlockFull: "Contact on WhatsApp",
    moreAvailable: "More Analysis Available",
    moreAnalysisDesc: "Contact us on WhatsApp to unlock detailed personalized analysis including Four Key Palace Analysis, Career Insights, Relationship Compatibility, and much more.",
    createAccountCta: "Contact on WhatsApp Now",

    // Error messages (free-result page)
    errorNotFound: "Profile not found.",
    errorLoadFailed: "Failed to load chart data.",
    errorCalculationFailed: "Failed to calculate chart.",
    errorExpired: "This profile may have expired or been removed.",
  },
  
  // Free test ended page
  freeTestEnded: {
    title: "Free Test Currently Unavailable",
    description: "The free test is currently unavailable. Thank you for your interest in our 紫微斗数 (Zi Wei Dou Shu) chart analysis!",
    whatNow: "What Now?",
    createAccount: "You can still access all our features by contacting us on WhatsApp. Our full service offers:",
    feature1: "Full 紫微斗数 chart visualization and analysis",
    feature2: "Personalized consultations for yourself and others",
    feature3: "Detailed personality analysis and life predictions",
    feature4: "Expert insights and recommendations for your chart",
    signUpCta: "Contact on WhatsApp",
    signInCta: "Learn More",
    questions: "Questions or feedback?",
    contactUs: "Contact us on WhatsApp",
  },
  
  // Free test not started page
  freeTestNotStarted: {
    title: "Free Test Coming Soon",
    description: "Our promotional free test will be available soon. Please check back later!",
  },
  
  // Free test disabled page
  freeTestDisabled: {
    title: "Free Test Currently Unavailable",
    description: "The free test feature is currently disabled. Please contact us on WhatsApp for more information about our services.",
  },
  
  // Promotional component
  freeTestPromo: {
    limitedOffer: "FREE TEST",
    daysLeft: "NO ACCOUNT NEEDED",
    title: "Free 紫微斗数 Chart Reading",
    description: "Experience the power of 紫微斗数 (Zi Wei Dou Shu) chart analysis for free. No account required!",
    tryNow: "Try It Now",
    createAccount: "Contact on WhatsApp",
  }
};

export default freeTest; 